
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'data-privacy-request-ui',
  currentProjectVersion: 'static-1.5725',
  depVersions: {
  "data-privacy-request-ui": "static-1.5725",
  "client-types": "static-1.489",
  "data-fetching-client": "static-1.9866",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8235",
  "hub-http-shared-msw-handlers": "static-1.10457",
  "hubspot-dlb": "static-2.1854",
  "HubStyleTokens": "static-2.11683",
  "I18n": "static-7.1651",
  "jasmine-runner": "static-1.6663",
  "quartz": "static-1.7307",
  "react-dlb": "static-1.83",
  "rpc-client-utils": "static-1.4867",
  "ui-components-test-utils": "static-1.5820",
  "UIComponents": "static-3.8629",
  "webpack-env": "static-1.54",
  "apollo-stack-hubspot": "static-3.89",
  "foundations-assets": "static-1.5084",
  "foundations-components": "static-1.8318",
  "foundations-components-test-utils": "static-1.5801",
  "foundations-theming": "static-1.4652",
  "hub-http": "static-1.6426",
  "quartz-config": "static-1.1085",
  "quartz-core": "static-1.6526",
  "quartz-routing": "static-1.737",
  "quick-fetch": "static-1.4062",
  "raven": "static-3.5925",
  "react": "static-7.189",
  "react-rhumb": "static-1.16912",
  "SharedI18nStrings": "static-1.182",
  "ui-addon-i18n": "static-1.11356",
  "usage-tracker": "static-1.7561",
  "usage-tracker-anonymous": "static-1.5978",
  "usage-tracker-core": "static-1.7411",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "hubspot-url-utils": "static-1.4132",
  "immutable": "static-2.79",
  "metrics-js": "static-1.9637",
  "react-redux": "static-7.71",
  "redux": "static-4.16",
  "styled-components": "static-2.89",
  "bend-plugin-trellis-migration": "static-1.3544",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3584",
  "quartz-webpack": "static-1.3531",
  "bend-plugin-quartz-routing": "static-1.385",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.85",
  "HeadJS": "static-2.782",
  "framer-motion": "static-1.75",
  "hs-test-utils-bend-plugin": "static-1.3346",
  "msw": "static-1.39",
  "testing-library": "static-1.155",
  "ts-schema": "static-1.4225",
  "i18n-data": "static-1.225",
  "moment-timezone": "static-5.86",
  "react-utils": "static-2.5486",
  "StyleGuideUI": "static-3.491",
  "jasmine": "static-4.4532",
  "bend-plugin-chirp-manifest": "static-1.277",
  "chirp-fetch": "static-1.2097",
  "HubStyle": "static-2.11990",
  "ui-addon-draggable": "static-3.4963",
  "cssUtils": "static-1.854",
  "hs-story-utils": "static-1.9634",
  "icons": "static-2.668",
  "react-create-root-preference": "static-1.51",
  "react-select-plus": "static-1.108",
  "react-virtualized": "static-2.102",
  "ui-images": "static-2.1215",
  "bend-plugin-foundations-components": "static-1.4587",
  "floating-ui": "static-1.60",
  "foundations-theming-specialty": "static-1.2368",
  "react-aria": "static-1.69",
  "tanstack-table": "static-1.58",
  "trellis-assets": "static-1.2354",
  "ui-fonts": "static-1.945",
  "foundations-components-legacy": "static-1.1343",
  "bend-plugin-foundations-theming": "static-1.3135",
  "foundations-theming-base": "static-1.3637",
  "stylex": "static-1.37",
  "hs-locale-management": "static-1.226",
  "dispatcher": "static-1.140",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.859",
  "hubspotter-http": "static-1.4796",
  "mobile-manifest-mixins": "static-1.556",
  "module-federation": "static-1.29",
  "quartz-auth": "static-1.982",
  "quartz-head": "static-1.972",
  "quartz-i18n": "static-1.982",
  "quartz-test": "static-1.982",
  "quartz-tracking": "static-1.686",
  "trellis-components": "static-1.2373",
  "usage-tracker-container": "static-1.7551",
  "csstype": "static-1.50",
  "web-vitals": "static-1.9",
  "react-input-autosize": "static-2.17",
  "bender-build-tools": "static-1.3323",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-flip-move": "static-1.74",
  "sassPrefix": "static-1.160",
  "hubspotter-http-shared-msw-handlers": "static-1.10455",
  "usage-tracker-session-replay": "static-1.5247",
  "base-ui": "static-1.17",
  "react-day-picker": "static-1.6",
  "trellis-theming": "static-1.1163",
  "tanstack-virtual": "static-1.33",
  "amplitude-session-replay-browser": "static-1.60"
},
  depPathPrefixes: {
  "data-privacy-request-ui": "/data-privacy-request-ui/static-1.5725",
  "client-types": "/client-types/static-1.489",
  "data-fetching-client": "/data-fetching-client/static-1.9866",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8235",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10457",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "HubStyleTokens": "/HubStyleTokens/static-2.11683",
  "I18n": "/I18n/static-7.1651",
  "jasmine-runner": "/jasmine-runner/static-1.6663",
  "quartz": "/quartz/static-1.7307",
  "react-dlb": "/react-dlb/static-1.83",
  "rpc-client-utils": "/rpc-client-utils/static-1.4867",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.5820",
  "UIComponents": "/UIComponents/static-3.8629",
  "webpack-env": "/webpack-env/static-1.54",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.89",
  "foundations-assets": "/foundations-assets/static-1.5084",
  "foundations-components": "/foundations-components/static-1.8318",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5801",
  "foundations-theming": "/foundations-theming/static-1.4652",
  "hub-http": "/hub-http/static-1.6426",
  "quartz-config": "/quartz-config/static-1.1085",
  "quartz-core": "/quartz-core/static-1.6526",
  "quartz-routing": "/quartz-routing/static-1.737",
  "quick-fetch": "/quick-fetch/static-1.4062",
  "raven": "/raven/static-3.5925",
  "react": "/react/static-7.189",
  "react-rhumb": "/react-rhumb/static-1.16912",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11356",
  "usage-tracker": "/usage-tracker/static-1.7561",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5978",
  "usage-tracker-core": "/usage-tracker-core/static-1.7411",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "immutable": "/immutable/static-2.79",
  "metrics-js": "/metrics-js/static-1.9637",
  "react-redux": "/react-redux/static-7.71",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.89",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3544",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3584",
  "quartz-webpack": "/quartz-webpack/static-1.3531",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.385",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.85",
  "HeadJS": "/HeadJS/static-2.782",
  "framer-motion": "/framer-motion/static-1.75",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3346",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.155",
  "ts-schema": "/ts-schema/static-1.4225",
  "i18n-data": "/i18n-data/static-1.225",
  "moment-timezone": "/moment-timezone/static-5.86",
  "react-utils": "/react-utils/static-2.5486",
  "StyleGuideUI": "/StyleGuideUI/static-3.491",
  "jasmine": "/jasmine/static-4.4532",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.277",
  "chirp-fetch": "/chirp-fetch/static-1.2097",
  "HubStyle": "/HubStyle/static-2.11990",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4963",
  "cssUtils": "/cssUtils/static-1.854",
  "hs-story-utils": "/hs-story-utils/static-1.9634",
  "icons": "/icons/static-2.668",
  "react-create-root-preference": "/react-create-root-preference/static-1.51",
  "react-select-plus": "/react-select-plus/static-1.108",
  "react-virtualized": "/react-virtualized/static-2.102",
  "ui-images": "/ui-images/static-2.1215",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4587",
  "floating-ui": "/floating-ui/static-1.60",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2368",
  "react-aria": "/react-aria/static-1.69",
  "tanstack-table": "/tanstack-table/static-1.58",
  "trellis-assets": "/trellis-assets/static-1.2354",
  "ui-fonts": "/ui-fonts/static-1.945",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1343",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3135",
  "foundations-theming-base": "/foundations-theming-base/static-1.3637",
  "stylex": "/stylex/static-1.37",
  "hs-locale-management": "/hs-locale-management/static-1.226",
  "dispatcher": "/dispatcher/static-1.140",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.859",
  "hubspotter-http": "/hubspotter-http/static-1.4796",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.556",
  "module-federation": "/module-federation/static-1.29",
  "quartz-auth": "/quartz-auth/static-1.982",
  "quartz-head": "/quartz-head/static-1.972",
  "quartz-i18n": "/quartz-i18n/static-1.982",
  "quartz-test": "/quartz-test/static-1.982",
  "quartz-tracking": "/quartz-tracking/static-1.686",
  "trellis-components": "/trellis-components/static-1.2373",
  "usage-tracker-container": "/usage-tracker-container/static-1.7551",
  "csstype": "/csstype/static-1.50",
  "web-vitals": "/web-vitals/static-1.9",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "bender-build-tools": "/bender-build-tools/static-1.3323",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-flip-move": "/react-flip-move/static-1.74",
  "sassPrefix": "/sassPrefix/static-1.160",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10455",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5247",
  "base-ui": "/base-ui/static-1.17",
  "react-day-picker": "/react-day-picker/static-1.6",
  "trellis-theming": "/trellis-theming/static-1.1163",
  "tanstack-virtual": "/tanstack-virtual/static-1.33",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60"
}
};
